<script>
  import classNames from 'classnames';

  let className = '';

  export { className as class };
  export let level = 1;

  const baseClass = 'font-bold text-gray-900';
  const classes = classNames(baseClass, className);
</script>

{#if level === 1}
  <h1 class={classNames('text-2xl md:text-3xl', classes)}><slot /></h1>
{:else if level === 2}
  <h2 class={classNames('text-2xl', classes)}><slot /></h2>
{:else if level === 3}
  <h3 class={classNames('text-2xl', classes)}><slot /></h3>
{:else if level === 4}
  <h4 class={classNames('text-2xl', classes)}><slot /></h4>
{:else if level === 5}
  <h5 class={classNames('text-2xl', classes)}><slot /></h5>
{:else if level === 6}
  <h6 class={classNames('text-2xl', classes)}><slot /></h6>
{:else}
  <h1 class={classNames('text-2xl md:text-3xl', classes)}><slot /></h1>
{/if}
